import { useContext } from 'react';
import { UserCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import ButtonHub from '../../atoms/buttonHub/view.js';

import './style.css';
import { roleContext } from '../../../context/role/context.js';

function HubButtonsGroup({ profile, suscripcion, replace, logOut }) {

    const { addons } = useContext(roleContext)
    const navigate = useNavigate();

    return (
        <div className='grid-container'>
            <ButtonHub
                id="profile"
                onClick={() => { navigate('/profile') }}
                title="Perfil"
                icon={<UserCircle />}
            />
            {
                addons?.map((addon) => {
                    return addon.action ? (
                        <ButtonHub key={addon.id} id={addon.id} onClick={addon.action} title={addon.title} icon={addon.icon} disabled={addon.disabled ? addon.disabled : false} />
                    ) : (
                        <ButtonHub key={addon.id} id={addon.id} onClick={() => { navigate(addon.link) }} title={addon.title} icon={addon.icon} disabled={addon.disabled ? addon.disabled : false} />
                    )
                })
            }
        </div>
    );
}

export default HubButtonsGroup;
